import { InputDiagramsType } from 'helper/converter/measurement-diagrams-converter/measurement-diagrams-converter';
import { mapBackendItemType } from 'store/programItems';
import { ProgramType } from '../programs';
import { DashboardActionType } from './dashboard.actionCreators';
import {
	DASHBOARD_LOADING,
	FLUSH_PROGRAM,
	RECEIVED_DASHBOARD_MEASUREMENT,
	RECEIVED_DASHBOARD_MEASUREMENT_DIAGRAM,
	RECEIVED_OVERVIEW,
	RECEIVED_PROGRAM,
	REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM,
	REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS,
} from './dashboard.actionTypes';

export type SaveMeasurmenetType = {
	weight: number;
	waist: number;
	bodyFat: number;
};

export type TodoType = {
	id: string;
	done: boolean;
	type?: string;
	icon: string;
};

export type PayloadType = {
	currentDay: {
		programItems: Array<TodoType>;
	};
};

export type TrackingHistoryItemType = {
	label: string;
	value: number;
	dateTime?: {
		time: string;
		date: string;
	};
	weight?: number;
};

export type NormalizedTrackingHistoryItemType = TrackingHistoryItemType & {
	time?: string;
	date?: string;
};

export type TrackingHistoryType = Array<TrackingHistoryItemType>;

export const MEASUREMENT_DIAGRAM_TYPE = {
	WEIGHT: 'WEIGHT',
	WAIST: 'WAIST',
	BODY_FAT: 'BODY_FAT',
};
export type MeasurementDiagramTypeType = keyof typeof MEASUREMENT_DIAGRAM_TYPE;

export const MEASUREMENT_DIAGRAM_PERIOD = {
	A: 'A',
	M1: 'M1',
	M2: 'M2',
};
export type MeasurementDiagramPeriodType = keyof typeof MEASUREMENT_DIAGRAM_PERIOD;

export type MeasurementDiagramType = {
	loading: boolean;
	selectedType?: MeasurementDiagramTypeType;
	updateKey?: string;
	diagram?: InputDiagramsType;
	fetchCounter: number;
};

export type OverviewType = {
	calories: number;
	totalTodos: number;
	totalTodosDone: number;
	overallNumberOfDays: number;
	currentDayNumber: number;
	coachMotivation: string;
	trackingHistory: TrackingHistoryType;
	initialWeightLost: number;
	anamnesisTimestamp: any;
	healthGoal: string;
	desiredWeight: number;
	weightReduceGoal: number;
	currentWeight: number;
	weightLost: number;
	currentDay: {
		programItems?: Array<TodoType>;
		date?: {
			date?: string;
		};
	};
};

export type TodoStatsType = {
	total: number;
	done: number;
	percentage: number;
};

export type ActivityType = {
	type: string;
	count?: number | string;
};

export type ActivitiesType = Array<ActivityType | undefined>;

export type DaysStatsType = {
	total: number;
	done: number;
	percentage: number;
};

export type DashboardStateType = {
	readonly loading: boolean;
	readonly program: null | ProgramType;
	readonly measurement: null | TrackingHistoryItemType;
	readonly measurementDiagram: MeasurementDiagramType;
	readonly todos: Array<TodoType>;
	readonly overview: null | OverviewType;
};

export type RootStateType = {
	dashboard: DashboardStateType;
};

export const initialState: DashboardStateType = {
	loading: false,
	program: null,
	measurement: null,
	measurementDiagram: {
		loading: true,
		fetchCounter: 0,
	},
	todos: [],
	overview: null,
};

export default (state: DashboardStateType = initialState, action: DashboardActionType): DashboardStateType => {
	switch (action.type) {
		case FLUSH_PROGRAM:
			return { ...state, program: null };
		case DASHBOARD_LOADING:
			return { ...state, loading: action.loading };
		case RECEIVED_PROGRAM:
			return { ...state, program: action.payload as any };
		case RECEIVED_DASHBOARD_MEASUREMENT:
			return { ...state, measurement: action.payload };
		case REQUEST_DASHBOARD_MEASUREMENT_DIAGRAM:
			return {
				...state,
				measurementDiagram: {
					...state.measurementDiagram,
					selectedType: action.selectedType,
					updateKey: `REQUEST_${action.selectedType}_${state.measurementDiagram.fetchCounter}`,
					loading: true,
				},
			};
		case RECEIVED_DASHBOARD_MEASUREMENT_DIAGRAM:
			return {
				...state,
				measurementDiagram: {
					...state.measurementDiagram,
					updateKey: `RECEIVED_${state.measurementDiagram.selectedType || ''}_${
						state.measurementDiagram.fetchCounter
					}`,
					loading: false,
					diagram: action.payload,
					fetchCounter: state.measurementDiagram.fetchCounter + 1,
				},
			};
		case REQUEST_SAVE_DASHBOARD_MEASUREMENT_SUCCESS:
			return {
				...state,
				overview: {
					...(state.overview as OverviewType),
					currentWeight: action.measurement.weight,
				},
			};
		case RECEIVED_OVERVIEW:
			const overview = { ...action.payload };
			let todos: Array<TodoType> = [];

			if (overview.currentDay) {
				todos = overview.currentDay.programItems
					? overview.currentDay.programItems.map((item: TodoType) => ({
							...item,
							type: mapBackendItemType(item.type || ''),
							originalType: item.type,
					  }))
					: [];

				delete overview.currentDay.programItems;
			}

			return {
				...state,
				overview,
				todos,
			};
		default:
			return state;
	}
};

// Selectors
// ------------------------------------
